import TourPage from "@/components/TourPage";

export default function UgandaWildlife5Day() {
  return (
    <TourPage
      tourId="uganda/wildlife-5-day"
      title="5-Day Uganda Wildlife Safari"
      duration="5 Days / 4 Nights"
      price="Contact for price"
      image="/Uganda-Wildlife-Safari.png"
      description="Experience the best of Uganda's wildlife in this comprehensive 5-day safari covering Murchison Falls National Park and Queen Elizabeth National Park. Witness diverse wildlife, stunning landscapes, and unforgettable moments in the pearl of Africa."
      itinerary={[
        {
          day: 1,
          title: "Kampala to Murchison Falls",
          description: "Journey to Uganda's largest national park.",
          activities: [
            "Morning departure from Kampala",
            "Visit Ziwa Rhino Sanctuary",
            "Arrive at Murchison Falls National Park",
            "Evening relaxation at the lodge"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Murchison Falls Experience",
          description: "Full day exploring Murchison Falls.",
          activities: [
            "Morning game drive",
            "Afternoon boat cruise to the falls",
            "Hike to the top of the falls",
            "Evening game drive"
          ],
          accommodation: "Paraa Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Transfer to Queen Elizabeth",
          description: "Travel to Queen Elizabeth National Park.",
          activities: [
            "Morning game drive in Murchison",
            "Drive to Queen Elizabeth National Park",
            "Evening game drive if time permits"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Queen Elizabeth Safari",
          description: "Explore Queen Elizabeth National Park.",
          activities: [
            "Early morning game drive",
            "Search for tree-climbing lions",
            "Afternoon boat cruise on Kazinga Channel",
            "Evening game drive"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Return to Kampala",
          description: "Final game drive and return journey.",
          activities: [
            "Morning game drive",
            "Drive back to Kampala",
            "Stop at the equator",
            "Evening arrival in Kampala"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Park entrance fees",
        "4x4 safari vehicle",
        "English-speaking guide",
        "Boat cruises",
        "Game drives",
        "Accommodation as listed",
        "Meals as specified",
        "Bottled water"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities"
      ]}
    />
  );
}
